import { InjectedContentBlock } from "@omni/types/api/search/bff/injectedContentBlock.model";
import { cn } from "@omni/utils/styles";

type ContentBlockComponentProps = {
    content: InjectedContentBlock;
    expandImage: boolean;
};

export const ContentBlockComponent = ({
    content,
    expandImage
}: ContentBlockComponentProps) => (
    <span className={cn("tw:contents")}>
        {content.imageUrl && (
            <img
                className={cn("tw:object-cover tw:w-full", {
                    "tw:h-full tw:rounded-md": expandImage,
                    "tw:sm:aspect-[1.33] tw:mb-12": !expandImage
                })}
                src={content.imageUrl}
                alt={content.title}
                data-sizes={"auto"}
                data-src={content.imageUrl}
            />
        )}
        {content.title && (
            <h5 className={cn("tw:text-primary tw:line-clamp-2")}>
                {content.title}
            </h5>
        )}
        {content.description && (
            <p className={cn("tw:mb-0")}>{content.description}</p>
        )}
    </span>
);
